import Header from '@/components/Header';
import Footer from '@/components/Footer';

import Hero from '@/components/section/Hero';
import About from '@/components/section/About';
import Projects from '@/components/section/Projects';
import Skills from '@/components/section/Skills';
import Experience from '@/components/section/Experience';
import ProblemsSolved from '@/components/section/ProblemsSolved';
import DevOpsShowcase from '@/components/section/DevOpsShowcase';
import Contact from '@/components/section/Contact';

const Home = () => {
  return (
    <div className="min-h-screen overflow-x-hidden bg-white dark:bg-[#0a0e1a] transition-colors duration-300">
      <Header />
      <main className="flex flex-col">
        <Hero />
        <About />
        <Projects />
        <Skills />
        <Experience />
        <ProblemsSolved />
        <DevOpsShowcase />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
